
import { Card, Col, Divider, Form, Input, Row, Space, Select } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonAction from 'components/Common/ButtonAction';
import { ButtonAdd } from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import CustomAntdTable from 'components/Common/CustomAntdTable';
import { dismissToast, errorToast, successToast, loadingToastId } from 'utils/Toast';
import Constant from 'utils/Constants';
import { sorterTable } from 'utils/Helper';
import useIsMobileHooks from 'hooks/useIsMobileHooks';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import SkeletonPage from 'components/Common/SkeletonPage';
import { ButtonAdvanceFilter } from 'components/Common/ButtonAdvanceFilter';
import Error403 from 'components/Error/Error403';
import BaseAdvanceFilter from 'components/CustomDrawer/BaseAdvanceFilter';
import CellTable from 'components/Common/CellTable';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useDivisionRepo from "../../../services/repo/useDivisionRepo";
import useOrgRepo from "../../../services/repo/useOrgRepo";
// import LocalStorageUtils from 'utils/LocalStorage';

export default function Division() {

    useTopbarTitleHooks("Division");
    const { isLoading: isLoadingList, getDivisionList } = useDivisionRepo(false)
    const { isLoading: isLoadingDelete, deleteDivision } = useDivisionRepo(false);
    const { isLoading: isLoadingOrgList, getOrgList } = useOrgRepo(false)
    // const userInfo = LocalStorageUtils.userInfo.get();
    // const defaultOrgId = userInfo?.orgId || null;
    const isFirstOrgInit = useRef(true);
    const isMobile = useIsMobileHooks()
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const [data, setData] = useState()
    const [totalData, setTotalData] = useState(0)
    const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false)
    const isLoadingPrivilege = useRef(true)
    const hasPrivilegePage = useRef(true)
    const [isLoadedPrivilege, setIsLoadedPrivilege] = useState(false)
    const [showButtonAdd, setShowButtonAdd] = useState(false)

    const [filters, setFilters] = useState({
        divCode: "",
        divName: "",
        orgId: null,
        status: ""
    })

    const [tableParams, setTableParams] = useState({
        pageNumber: 1,
        pageSize: 10,
        filter: { ...filters },
        orderBy: "divName",
        isAscending: true
    });

    const onSearch = () => {
        const formValues = form.getFieldsValue();
        const selectedOrg = formValues.orgId;
        const orgId = selectedOrg?.value ?? selectedOrg ?? null;

        setTableParams(prev => ({
            ...prev,
            pageNumber: 1,
            filter: {
                ...filters,
                orgId: orgId
            }
        }));
    };


    const onSearchClick = () => {
        onSearch()
        setIsOpenAdvanceFilter(false)
    }

    const fetchData = async () => {

        const payload = {
            ...tableParams
        }
        const res = await getDivisionList(payload)
        if (res?.detail == 'OK' && res?.status === 200) {
            setData(res?.data?.content)
            setTotalData(res?.data?.totalElements)
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pageNumber: pagination?.current,
            pageSize: pagination?.pageSize,
            orderBy: sorter?.field || prevParams?.orderBy,
            isAscending: sorterTable(sorter?.order, prevParams?.isAscending)
        }));
        if (pagination.pageSize !== tableParams?.pageSize) {
            setData([]);
        }
    };

    const handleAdd = () => {
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.division.create);
    }

    const handleEdit = async (data) => {
        const key = 'loadingEdit';
        loadingToastId(Constant.message.loading, key)
        navigate(APP_ROUTE_PREFIX + "/" + RouteConstant.organization.division.edit(data?.divId));
        dismissToast(key)
    }

    const handleDelete = async (record) => {
        const key = 'deleteDivision';
        try {

            debugger

            loadingToastId(Constant.message.loading, key)

            const response = await deleteDivision({ divId: record.divId });

            if (response?.status === 200 && response?.detail === 'OK') {
                successToast(Constant.message.deleteDataSuccess);
                fetchData(); // refresh table
            } else {
                errorToast(Constant.message.deleteDataFail);
            }
        } catch (error) {
            console.error('Error:', error);
            errorToast(Constant.message.deleteDataFail);
        } finally {
            dismissToast(key); //tambahkan ini agar loading hilang
        }
    };


    const fetchCheckPrivilege = async () => {
        setShowButtonAdd(true)
        isLoadingPrivilege.current = false
        hasPrivilegePage.current = true;
        setIsLoadedPrivilege(true)
        await fetchData();
        dismissToast(PRIVILEGE_ID.AddEditDivision);
    }

    // Org dropdown
    const hasAutoSelectedOrg = useRef(false);
    const [orgOptions, setOrgOptions] = useState([])
    const fetchDataOrg = async () => {
        const payload = {
            pageNumber: 1,
            pageSize: 0,
            orderBy: "orgId",
            isAscending: true,
            filter: {
                ...filters
            }
        };

        console.log("🟡 Available orgOptions:", orgOptions);

        const res = await getOrgList(payload);

        if (res?.detail === 'OK' && res?.status === 200) {
            const options = res.data.content.map(item => ({
                label: item?.orgName,
                value: item?.orgId,
            }));

            setOrgOptions(options);

            if (options.length === 1) {
                const onlyOption = options[0];

                form.setFieldsValue({ orgId: onlyOption }); // isinya harus { label, value }
                setFilters((prev) => ({ ...prev, orgId: onlyOption.value }));

                setTableParams((prev) => ({
                    ...prev,
                    filter: {
                        ...prev.filter,
                        orgId: onlyOption.value
                    }
                }));
            }
            // Jangan paksa set orgId di sini jika length > 1
            // if (!hasAutoSelectedOrg.current && defaultOrgId && options.length === 1) {
            //     const match = options.find(opt => opt.value === defaultOrgId);
            //     if (match) {
            //         form.setFieldsValue({ orgId: match });
            //         // setFilters(prev => ({
            //         //     ...prev,
            //         //     orgId: match.value
            //         // }));

            //         setTableParams((prev) => ({
            //             ...prev,
            //             filter: {
            //                 ...prev.filter,
            //                 orgId: match.value
            //             }
            //         }));

            //         hasAutoSelectedOrg.current = true; // jangan lakukan lagi
            //     }
            // }

        }
    };


    useEffect(() => {
        fetchCheckPrivilege()
    }, [])


    useEffect(() => {

        if (isLoadedPrivilege) {
            fetchData();
        }

        fetchDataOrg();
    }, [JSON.stringify(tableParams)]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (isLoadedPrivilege && !isMobile) {
                onSearch()
            }
        }, Constant.delayFilter);
        return () => clearTimeout(timeOutId);
    }, [filters]);


    const filterUI = () => {
        return (
            <Form
                layout="horizontal"
                form={form}
                // initialValues={{
                //     orgId: orgOptions.find(o => o.value === defaultOrgId) ?? undefined
                // }}
            >

                <Row gutter={16}>
                    <Col xs={24} sm={10} md={8}>
                        <Form.Item name='orgId' label="Filter By">
                            <Select
                                style={{ width: '100%' }}
                                allowClear
                                showSearch
                                placeholder='Select Organization'
                                loading={isLoadingOrgList}
                                options={orgOptions}
                                // 🟢 Trigger ketika user memilih / clear
                                onChange={(selectedValue) => {
                                    const orgId = selectedValue ?? null; // null if cleared

                                    form.setFieldsValue({ orgId: orgId });

                                    // ✅ Trigger filter dan refresh table
                                    setTableParams((prev) => ({
                                        ...prev,
                                        pageNumber: 1,
                                        filter: {
                                            ...prev.filter,
                                            orgId: orgId
                                        }
                                    }));
                                }}
                                // 🟢 Fitur pencarian
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </Form.Item>



                    </Col>

                    <Col xs={16} sm={10} md={6}>
                        <Form.Item name='divCodeFilter' >
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterCode}
                                onChange={(e) => {
                                    setFilters(prev => ({
                                        ...prev,
                                        divCode: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={10} md={6}>
                        <Form.Item name='divNameFilter'>
                            <Input
                                allowClear
                                placeholder={Constant.placeholder.enterName}
                                onChange={e => {
                                    setFilters(prev => ({
                                        ...prev,
                                        divName: e.target.value
                                    }))
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={10} md={4}>
                        <Form.Item name='statusFilter'>
                            <Select
                                allowClear
                                placeholder="Select Status"
                                onChange={(value) => {
                                    setFilters(prev => ({
                                        ...prev,
                                        status: value
                                    }));
                                }}
                            >
                                <Select.Option value="true">Active</Select.Option>
                                <Select.Option value="false">Inactive</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>


                </Row>
            </Form>
        )
    }

    const columns = [
        {
            title: 'Action',
            key: 'action',
            width: "50px",
            render: (_, record) => {
                const buttons = showButtonAdd ? ['edit', 'delete'] : ['delete']
                return (
                    <ButtonAction
                        buttons={buttons}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                        data={record}
                        loadingDelete={isLoadingDelete}
                    />
                )
            }
        },
        {
            title: 'Organization',
            dataIndex: 'orgName',
            sorter: true,
            width: "200px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Code',
            dataIndex: 'divCode',
            sorter: true,
            width: "170px",
            render: (data) => <CellTable data={data} />
        },
        {
            title: 'Name',
            dataIndex: 'divName',
            width: "200px",
            sorter: true,
            render: (data) => <CellTable data={data} />
        },

        {
            title: 'Status',
            dataIndex: 'status',
            width: "100px",
            sorter: true,
            render: (data) => <CellTable data={String(data).toLowerCase() === "true" ? "Active" : "Inactive"} />
        }
    ];
    return (
        <>
            {hasPrivilegePage.current ?
                <Space direction="vertical" size="large" className='space-vertical-flex'>
                    <Card size="big" bordered={false}>
                        {isLoadingPrivilege.current ? <SkeletonPage /> :
                            <>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={20} xl={18}>
                                        {showButtonAdd && <ButtonAdd onClick={handleAdd} />}
                                    </Col>
                                </Row>
                                <Divider dashed className='mb-1 mt-1' />

                                {isMobile ?
                                    <ButtonAdvanceFilter onClick={() => setIsOpenAdvanceFilter(true)} />
                                    : filterUI()
                                }

                                <CustomAntdTable
                                    columns={columns}
                                    dataSource={data}
                                    rowKey={"divId"}
                                    tableParam={tableParams}
                                    totalData={totalData}
                                    loading={isLoadingList}
                                    onChange={handleTableChange}
                                // rowClick={handleRowClick}
                                // isOpenDrawer={isOpenDrawer}
                                // idDataHighlight={idHighlightRow}
                                />
                            </>
                        }
                    </Card>
                </Space> : (<Error403 />)
            }

            {isOpenAdvanceFilter &&
                <BaseAdvanceFilter
                    onClose={() => setIsOpenAdvanceFilter(false)}
                    onSearchClick={onSearchClick}>
                    {filterUI()}
                </BaseAdvanceFilter>}
        </>
    )
}
